import React from "react";
import { List, Tag, Typography } from "antd";
import { Link } from "react-router-dom";
import theme from "../common/theme";
import _ from "lodash";

const { Text, Title } = Typography;
const PostInfo = ({ post }) => {
  const { id, categories, tags } = post;

  return (
    <List bordered itemLayout="horizontal">
      <List.Item>
        <List.Item.Meta
          title={<Title level={5}>编号</Title>}
          description={<Text strong>{id}</Text>}
        />
      </List.Item>
      <List.Item>
        <List.Item.Meta
          title={<Title level={5}>分类</Title>}
          description={categories.map((category) => (
            <div key={category.id} style={{ margin: "0.5rem" }}>
              <Tag color={"blue"}>
                <Link to={category.path} style={{ color: theme.primary }}>
                  {category.name}
                </Link>
              </Tag>
            </div>
          ))}
        />
      </List.Item>
      {!_.isEmpty(tags) && (
        <List.Item>
          <List.Item.Meta
            title={<Title level={5}>标签</Title>}
            description={tags.map((tag) => (
              <div key={tag}>
                <Tag color={"green"} style={{ margin: "0.5rem" }}>
                  {tag}
                </Tag>
              </div>
            ))}
          />
        </List.Item>
      )}
    </List>
  );
};

export default PostInfo;
